import AutocompleteTagComponent from './autocomplete-tag.component'

const AutocompleteTagModule = angular.module('cdbl.autocomplete-tag', [

])
  .component('cdblAutocompleteTag', AutocompleteTagComponent)
  .name

export default AutocompleteTagModule
